var fr_CA = {};
module['exports'] = fr_CA;
fr_CA.title = "French (Canada)";
fr_CA.address = require("./address");
fr_CA.internet = require("./internet");
fr_CA.phone_number = require("./phone_number");